
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/_experiment",
      function () {
        return require("private-next-pages/[locale]/watch/_experiment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/_experiment"])
      });
    }
  